import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreType, storeTypes } from '../../../../models/business-information.model';

@Component({
  selector: 'app-browse-category',
  templateUrl: './browse-category.component.html',
  styleUrls: ['./browse-category.component.css']
})
export class BrowseCategoryComponent implements OnInit {
  storeTypes = Object.values(storeTypes);
  storeTypeOptions: (StoreType | 'all')[] = ['all', ...Object.values(storeTypes)];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onCategoryClick(storeType: StoreType | 'all'): void {
    // Navigate to stores page with filter
    if (storeType === 'all') {
      this.router.navigate(['/businesses']);
    } else {
      this.router.navigate(['/businesses'], {
        queryParams: { type: storeType }
      });
    }
  }
}
